var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SiteHeaderLayout } from './site-header-layout';
import { classNames } from '@shapeable/utils';
import { get, pick } from 'lodash';
import { SliceLayout } from './slice-layout';
import { ThemeModeProvider } from '../context/theme-mode-context';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('entity-title-header');
export var EntityTitleHeaderDefaultProps = {
  showOverlayGradient: false,
  isInverted: true,
  showPretitle: false,
  colors: {
    text: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background-repeat: no-repeat;\n    background-position: center center;\n\n    ", "\n\n    ", "\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background-repeat: no-repeat;\n    background-position: center center;\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var colors = _a.colors;
    return (colors === null || colors === void 0 ? void 0 : colors.background) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR(colors.background));
  }, function (_a) {
    var _backgroundImage = _a._backgroundImage,
      _overlayColor = _a._overlayColor,
      colors = _a.colors;
    return _backgroundImage && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-image: ", " url(", ");\n      background-size: cover;\n    "], ["\n      background-image: ", " url(", ");\n      background-size: cover;\n    "])), _overlayColor && "linear-gradient(to bottom, ".concat(_overlayColor, " 0%, ").concat(_overlayColor, " 100%),"), _backgroundImage);
  })
});
var SiteHeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-grow: 1;\n    color: inherit;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "], ["\n    flex-grow: 1;\n    color: inherit;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "])))
});
var PreTitleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 0.8em;\n    font-weight: 500;\n    color: inherit;\n    margin: ", " 0 0 0;\n    ", ";\n  "], ["\n    font-size: 0.8em;\n    font-weight: 500;\n    color: inherit;\n    margin: ", " 0 0 0;\n    ", ";\n  "])), theme.UNIT(4), theme.APPLY_COLORS),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 1em;\n    margin: ", " 0 0 0;\n  "], ["\n    font-size: 1em;\n    margin: ", " 0 0 0;\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: ", " 0 0 0;\n  "], ["\n    margin: ", " 0 0 0;\n  "])), theme.UNIT(8))
});
var TitleStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    font-size: 2em;\n    line-height: 1.15em;\n    font-weight: 500;\n    margin: ", " 0;\n\n    ", "\n  "], ["\n    ", ";\n    font-size: 2em;\n    line-height: 1.15em;\n    font-weight: 500;\n    margin: ", " 0;\n\n    ", "\n  "])), theme.APPLY_COLORS, theme.UNIT(4), function (_a) {
    var showPretitle = _a.showPretitle;
    return showPretitle && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  }),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    font-size: 2.25em;\n    margin: ", " 0;\n\n    ", "\n  "], ["\n    font-size: 2.25em;\n    margin: ", " 0;\n\n    ", "\n  "])), theme.UNIT(6), function (_a) {
    var showPretitle = _a.showPretitle;
    return showPretitle && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(3));
  }),
  desktop: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-size: 2.5em;\n    margin: ", " 0;\n\n    ", "\n\n  "], ["\n    font-size: 2.5em;\n    margin: ", " 0;\n\n    ", "\n\n  "])), theme.UNIT(8), function (_a) {
    var showPretitle = _a.showPretitle;
    return showPretitle && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(3));
  })
});
// -------- Components -------->
var My = {
  NAME: 'EntityTitleHeader',
  Container: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SiteHeader: styled(SiteHeaderLayout)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), SiteHeaderStyles),
  Body: styled(SliceLayout)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  PreTitle: styled.h3.attrs(cls.attr('pretitle'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), PreTitleStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var EntityTitleHeader = function (props) {
  var _a = useComponentProps(My.NAME, EntityTitleHeaderDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    colors = _a.colors,
    themeMode = _a.themeMode,
    isInverted = _a.isInverted,
    overlayColor = _a.overlayColor,
    backgroundImage = _a.backgroundImage,
    showPretitle = _a.showPretitle,
    siteHeaderProps = __rest(_a, ["className", "children", "entity", "colors", "themeMode", "isInverted", "overlayColor", "backgroundImage", "showPretitle"]);
  var hasPretitle = showPretitle && !!(entity === null || entity === void 0 ? void 0 : entity.pretitle);
  var pretitle = hasPretitle && entity.pretitle;
  var title = entity.title || entity.name;
  var bg = get(backgroundImage, 'image.url', null);
  var actualThemeMode = get(entity, 'bannerThemeMode.slug', themeMode || 'auto');
  if (bg) {
    actualThemeMode = 'dark';
  }
  return React.createElement(My.Container, {
    colors: colors,
    _overlayColor: overlayColor,
    _backgroundImage: bg,
    className: cls.name(className)
  }, React.createElement(SiteHeaderLayout, __assign({
    maxLogoHeight: 84,
    useLogoVerticalOffsets: true,
    variant: "overlay"
  }, siteHeaderProps)), React.createElement(My.Body, {
    variant: 'boundary',
    boundary: "content"
  }, React.createElement(ThemeModeProvider, {
    value: actualThemeMode
  }, hasPretitle && React.createElement(My.PreTitle, {
    showPretitle: hasPretitle,
    colors: colors
  }, pretitle), title && React.createElement(My.Title, {
    colors: pick(colors, 'text'),
    showPretitle: hasPretitle
  }, title), children)));
};
EntityTitleHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;